import React from "react";
import { Form } from "semantic-ui-react";

import { Menu } from "lib/components/vendor";

export default function ButtonSwitchControl({ onFocus, onBlur, onChange, value, readOnly, disabled, options = [] }) {
  if (options.length > 0 && !Array.isArray(options[0])) {
    options = options.map((v) => [v, v]);
  }

  const handleClick = (event, v) => {
    event.preventDefault();
    if (readOnly || disabled) {
      return;
    }
    onFocus && onFocus();
    onChange && onChange(v);
    onBlur && onBlur();
  };

  return (
    <Menu color="teal" widths={options.length}>
      {options.map(([v, label]) => (
        <Menu.Item
          key={v}
          as="a"
          onClick={(event) => handleClick(event, v)}
          active={value === v}
          disabled={readOnly || disabled}
          content={label}
        />
      ))}
    </Menu>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/ButtonSwitch.jsx